<template>
    <div class="talk_parent">
        <img class="ai_head_img2" src="../../assets/ai_head_msg.png">
        <div class="triangle_border_left"></div>
        <div class="talk_div">{{text}}</div>
    </div>
</template>

<script>
export default {
  props: ["text"],
  data() {
    return {
      testNums: 0
    };
  }
};
</script>


<style lang="scss" scoped>
.talk_parent {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 20px;
  margin-left: 10px;
}
.ai_head_img2 {
  width: 52px;
  height: 52px;
  margin-right: 6px;
}
.talk_div {
  min-width: 20px;
  background: #e1eeeb;
  border-radius: 4px;
  padding-left: 11px;
  padding-right: 11px;
  padding-top: 14px;
  padding-bottom: 14px;
  font-size: 14px;
   margin-right: 10px;
  color: #343434;
}
/*向左*/
.triangle_border_left {
  width: 0;
  height: 0;
  border-width: 6px 9px 6px 0;
  border-style: solid;
  margin-top: 15px;
  border-color: transparent #e1eeeb transparent transparent; /*透明 灰 透明 透明 */
  position: relative;
}
</style>
